import React, { useState } from "react";
import { IconSend } from "@tabler/icons-react";
import TextInput from "../elements/form/TextInput";
// Adjust this import path to match where TextInput lives in your project.

type IChatInputBar = {
  onSend: (content: string) => void;
  disabled: boolean;
};

const ChatInputBar: React.FC<IChatInputBar> = ({ onSend, disabled }) => {
  const [draft, setDraft] = useState("");

  const handleSend = () => {
    if (!draft.trim() || disabled) return;
    onSend(draft.trim());
    setDraft("");
  };

  return (
    <div className="border-t border-gray-50/20 px-4 py-3">
      <TextInput
        name="chatWidgetDraft"
        type="text"
        value={draft}
        placeholder="Ask about corporate setup..."
        required={false}
        onChange={(e) => setDraft(e.target.value)}
        right_icon={<IconSend size={16} />}
        onRightIconClick={handleSend}
      />
    </div>
  );
};

export default ChatInputBar;
